import { useReportBespoke } from "@iliotech/data-wire";
import { EyeIcon } from "./assets/EyeIcon";
import { EyeClosedIcon } from "./assets/EyeClosedIcon";
import s from "./ReportPreviewButton.module.scss";
import { observer } from "mobx-react-lite";

interface IProps {
  onExport: () => void;
}
export const ReportPreviewButton = observer(({ onExport }: IProps) => {
  const store = useReportBespoke();
  const isPreview = store.generating;
  return (
    <div onClick={onExport} className={s.left}>
      {isPreview ? <EyeClosedIcon /> : <EyeIcon />}
      <span>{isPreview ? "Edit" : "Preview"}</span>
    </div>
  );
});
